var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43903 9.52439C2.43903 5.88739 5.38739 2.93903 9.02439 2.93903C12.6614 2.93903 15.6098 5.88739 15.6098 9.52439C15.6098 11.2925 14.913 12.8978 13.779 14.0808C13.7428 14.1096 13.7078 14.1408 13.6743 14.1743C13.6408 14.2078 13.6096 14.2427 13.5808 14.279C12.3979 15.413 10.7925 16.1098 9.02439 16.1098C5.38739 16.1098 2.43903 13.1614 2.43903 9.52439ZM14.4851 16.7097C12.969 17.8637 11.0767 18.5488 9.02439 18.5488C4.04036 18.5488 0 14.5084 0 9.52439C0 4.54036 4.04036 0.5 9.02439 0.5C14.0084 0.5 18.0488 4.54036 18.0488 9.52439C18.0488 11.5767 17.3637 13.469 16.2098 14.9851L19.6428 18.4182C20.1191 18.8944 20.1191 19.6666 19.6428 20.1428C19.1666 20.6191 18.3944 20.6191 17.9182 20.1428L14.4851 16.7097Z",
    fill: "#F0AB2E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.050c58e9.svg";
export { ForwardRef as ReactComponent };